export default "__VITE_ASSET__CdulPAK3__"